var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedDispatchMinimalistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 322,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.333 214.667A53.662 53.662 0 00215.74 257.6H64.4a42.932 42.932 0 01-30.359-73.292A42.936 42.936 0 0164.4 171.733h193.2a64.403 64.403 0 0064.4-64.4 64.4 64.4 0 00-64.4-64.4H106.26a53.667 53.667 0 100 21.467H257.6a42.936 42.936 0 0139.784 26.45 42.93 42.93 0 01-9.301 46.859 42.942 42.942 0 01-30.483 12.558H64.4a64.401 64.401 0 00-64.4 64.4 64.398 64.398 0 0064.4 64.4h151.34a53.667 53.667 0 1052.593-64.4zM53.667 85.867a32.2 32.2 0 110-64.4 32.2 32.2 0 010 64.4zm214.666 214.666a32.2 32.2 0 11-.001-64.4 32.2 32.2 0 01.001 64.4z",
    fill: "url(#paint0_linear_1064_2004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1064_2004",
    x1: 161,
    y1: 0,
    x2: 161,
    y2: 322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#438BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedDispatchMinimalistic);
export default __webpack_public_path__ + "static/media/automated-dispatch-minimalistic.a6b7081664237a16af0634094c8bd46f.svg";
export { ForwardRef as ReactComponent };